export default "__VITE_ASSET__UMLW4bPQ__"